import { Component, OnInit } from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";
import { LegalComponent } from "../legal/legal.component";

@Component({
  selector: "legal-link",
  templateUrl: "./legal-link.component.html",
  styleUrls: ["./legal-link.component.scss"]
})
export class LegalLinkComponent implements OnInit {
  constructor(private nav: NavController, private modalCtrl: ModalController) {}
  ngOnInit() {}

  ngOnDestroy() {}

  async showLegal() {
    const modal = await this.modalCtrl.create({
      component: LegalComponent,
      cssClass: "modal"
    });
    return await modal.present();
  }
}
